import Avatar from './Avatar';

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/common/Avatar/index.js